var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0014 0.669312C6.63877 0.669312 0.669434 6.63865 0.669434 14.0013C0.669434 20.6546 5.5441 26.1693 11.9188 27.1733V17.856H8.5321V14.0013H11.9188V11.064C11.9188 7.71998 13.9094 5.87598 16.9534 5.87598C18.4121 5.87598 19.9401 6.13598 19.9401 6.13598V9.41465H18.2548C16.6014 9.41465 16.0841 10.444 16.0841 11.4986V13.9986H19.7788L19.1881 17.8533H16.0841V27.1706C22.4588 26.172 27.3334 20.656 27.3334 14.0013C27.3334 6.63865 21.3641 0.669312 14.0014 0.669312Z",
    fill: "var(--detail-color-light-2)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.750baa1a.svg";
export { ForwardRef as ReactComponent };